import { ElementRef } from '@angular/core';
import { DATA_EXPORT_FEATURE, GENERATE_PDF_REPORT_FEATURE, STATIC_PDF_FEATURE, } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.constants';
import { ASC, CSV_FORMAT, DESC, PDF_FORMAT } from 'NewAngular/constants/core.constants';
import { ContributionMetric } from 'SecuritiesApp/ts/enums/attribution.enums';
import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import { SecuritiesService } from 'SecuritiesApp/ts/services/securities.service';
import { PdfTitleModalComponent } from 'NewAngular/features/components/pdf-title-modal/pdf-title-modal.component';
import { formatDateString } from 'Core/redesign/utils/date';
import { downloadFileFromPostResponse, downloadUrl } from 'NewAngular/utils/download';
import * as i0 from "@angular/core";
import * as i1 from "AccountsApp/ts/services/accounts.service";
import * as i2 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i3 from "SecuritiesApp/ts/services/securities.service";
import * as i4 from "@angular/common";
import * as i5 from "../../../../../../../../../ycharts/static/ts/features/directives/disabled/disabled.directive";
import * as i6 from "../../../../../../../../../ycharts/static/ts/features/components/modals/help-modal/components/help-modal.component";
import * as i7 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i8 from "NewAngular/features/components/modals/loading-modal/loading-modal.component";
import * as i9 from "../../../../../../../../../ycharts/static/ts/features/components/loaders/loading-symbol/loading-symbol.component";
import * as i10 from "../../../module-upsell/module-upsell.component";
import * as i11 from "NewAngular/features/components/pdf-title-modal/pdf-title-modal.component";
import * as i12 from "../../../../../../../../../ycharts/static/ts/features/components/dropdowns/simple-dropdown/simple-dropdown.component";
const _c0 = ["pdfTitleModal"];
const _c1 = a0 => ({ open: a0 });
const _c2 = a0 => ({ active: a0 });
function AttributionAbsoluteTableComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10)(1, "div", 11)(2, "ul", 20)(3, "li", 21)(4, "a", 22);
    i0.ɵɵlistener("click", function AttributionAbsoluteTableComponent_div_6_Template_a_click_4_listener() { i0.ɵɵrestoreView(_r3); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.setMetric(ctx_r3.CONTRIBUTION_METRIC_WEIGHT)); });
    i0.ɵɵtext(5, "Weight");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "li", 21)(7, "a", 22);
    i0.ɵɵlistener("click", function AttributionAbsoluteTableComponent_div_6_Template_a_click_7_listener() { i0.ɵɵrestoreView(_r3); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.setMetric(ctx_r3.CONTRIBUTION_METRIC_DOLLARS)); });
    i0.ɵɵtext(8, "Dollars");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(9, "div", 23)(10, "ycn-simple-dropdown", 24);
    i0.ɵɵlistener("handler", function AttributionAbsoluteTableComponent_div_6_Template_ycn_simple_dropdown_handler_10_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.handleExport($event)); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c2, ctx_r3.metric === ctx_r3.CONTRIBUTION_METRIC_WEIGHT));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c2, ctx_r3.metric === ctx_r3.CONTRIBUTION_METRIC_DOLLARS));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("buttonClass", "btn btn-secondary")("config", ctx_r3.exportDropdownConfig)("dropdownClass", "dropdown-menu-with-icons");
} }
function AttributionAbsoluteTableComponent_table_9_tr_29_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "td");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td", 31);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td", 31);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "td", 31);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "td", 31);
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "td", 31);
    i0.ɵɵtext(14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "td", 31);
    i0.ɵɵtext(16);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(17, "td");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const holding_r6 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(holding_r6.display_security_id);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(holding_r6.security_name);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(holding_r6.weighting);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(holding_r6.one_month_contribution);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(holding_r6.three_month_contribution);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(holding_r6.six_month_contribution);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(holding_r6.ytd_contribution);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(holding_r6.one_year_contribution);
} }
function AttributionAbsoluteTableComponent_table_9_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "table", 25)(1, "thead")(2, "tr")(3, "th", 26);
    i0.ɵɵlistener("click", function AttributionAbsoluteTableComponent_table_9_Template_th_click_3_listener() { i0.ɵɵrestoreView(_r5); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.setTableSortProperties("display_security_id")); });
    i0.ɵɵelementStart(4, "span", 27);
    i0.ɵɵtext(5, "Symbol");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "th", 28);
    i0.ɵɵlistener("click", function AttributionAbsoluteTableComponent_table_9_Template_th_click_6_listener() { i0.ɵɵrestoreView(_r5); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.setTableSortProperties("security_name")); });
    i0.ɵɵelementStart(7, "span", 27);
    i0.ɵɵtext(8, "Name");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "th", 29);
    i0.ɵɵlistener("click", function AttributionAbsoluteTableComponent_table_9_Template_th_click_9_listener() { i0.ɵɵrestoreView(_r5); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.setTableSortProperties("weighting")); });
    i0.ɵɵelementStart(10, "span", 27);
    i0.ɵɵtext(11, "Weight");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(12, "th", 29);
    i0.ɵɵlistener("click", function AttributionAbsoluteTableComponent_table_9_Template_th_click_12_listener() { i0.ɵɵrestoreView(_r5); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.setTableSortProperties("one_month_contribution")); });
    i0.ɵɵelementStart(13, "span", 27);
    i0.ɵɵtext(14, "1 Month Contribution");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(15, "th", 29);
    i0.ɵɵlistener("click", function AttributionAbsoluteTableComponent_table_9_Template_th_click_15_listener() { i0.ɵɵrestoreView(_r5); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.setTableSortProperties("three_month_contribution")); });
    i0.ɵɵelementStart(16, "span", 27);
    i0.ɵɵtext(17, "3 Month Contribution");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(18, "th", 29);
    i0.ɵɵlistener("click", function AttributionAbsoluteTableComponent_table_9_Template_th_click_18_listener() { i0.ɵɵrestoreView(_r5); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.setTableSortProperties("six_month_contribution")); });
    i0.ɵɵelementStart(19, "span", 27);
    i0.ɵɵtext(20, "6 Month Contribution");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(21, "th", 29);
    i0.ɵɵlistener("click", function AttributionAbsoluteTableComponent_table_9_Template_th_click_21_listener() { i0.ɵɵrestoreView(_r5); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.setTableSortProperties("ytd_contribution")); });
    i0.ɵɵelementStart(22, "span", 27);
    i0.ɵɵtext(23, "YTD Contribution");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(24, "th", 29);
    i0.ɵɵlistener("click", function AttributionAbsoluteTableComponent_table_9_Template_th_click_24_listener() { i0.ɵɵrestoreView(_r5); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.setTableSortProperties("one_year_contribution")); });
    i0.ɵɵelementStart(25, "span", 27);
    i0.ɵɵtext(26, "1Y Contribution");
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(27, "th");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(28, "tbody");
    i0.ɵɵtemplate(29, AttributionAbsoluteTableComponent_table_9_tr_29_Template, 18, 8, "tr", 30);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r3.getSortNgClass("display_security_id"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r3.getSortNgClass("security_name"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r3.getSortNgClass("weighting"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r3.getSortNgClass("one_month_contribution"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r3.getSortNgClass("three_month_contribution"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r3.getSortNgClass("six_month_contribution"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r3.getSortNgClass("ytd_contribution"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r3.getSortNgClass("one_year_contribution"));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngForOf", ctx_r3.holdings);
} }
function AttributionAbsoluteTableComponent_ycn_loading_symbol_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-loading-symbol", 32);
} if (rf & 2) {
    i0.ɵɵproperty("loaderMessage", "Loading Data...");
} }
export class AttributionAbsoluteTableComponent {
    constructor(accountsService, eltRef, featureService, securitiesService) {
        this.accountsService = accountsService;
        this.eltRef = eltRef;
        this.featureService = featureService;
        this.securitiesService = securitiesService;
        this.fetchSubscription$ = null;
        this.holdings = [];
        this.loading = true;
        this.pageNum = 1;
        this.paginationInfo = { current_page_num: 1, num_pages: 1 };
        this.sortColumn = 'weighting';
        this.sortDirection = DESC;
        this.hasExportFeature = false;
        this.hasStaticPDFFeature = false;
        this.exportDropdownConfig = {
            title: {
                label: 'Export',
                icon: 'icon-export',
            },
            list: [],
        };
        this.exportLoading = false;
        this.USER = window.USER;
        this.CONTRIBUTION_METRIC_WEIGHT = ContributionMetric.WEIGHT;
        this.CONTRIBUTION_METRIC_DOLLARS = ContributionMetric.DOLLARS;
        this.hasExportFeature = this.featureService.userHasFeatures([DATA_EXPORT_FEATURE]);
        this.hasStaticPDFFeature = this.featureService.userHasSomeFeatures([
            STATIC_PDF_FEATURE,
            GENERATE_PDF_REPORT_FEATURE,
        ]);
    }
    ngOnInit() {
        this.fetchHoldings();
        this.exportDropdownConfig.list = [
            {
                type: 'option',
                label: 'Export Data',
                value: CSV_FORMAT,
                icon: 'icon-csv',
                disabled: !this.hasExportFeature,
            },
            {
                type: 'option',
                label: 'Export PDF',
                value: PDF_FORMAT,
                icon: 'icon-download',
                disabled: !this.hasStaticPDFFeature,
            },
        ];
    }
    ngOnDestroy() {
        if (this.fetchSubscription$ !== null)
            this.fetchSubscription$.unsubscribe();
    }
    /**
     * Set the new page number and fetch the new list.
     * @param newPageNum: New page number.
     */
    pageChanged(newPageNum) {
        this.pageNum = newPageNum;
        this.fetchHoldings();
    }
    /**
     * Sets sort column and sort direction when a column header is clicked
     * @param columnName: New sort column name.
     */
    setTableSortProperties(columnName) {
        if (columnName === this.sortColumn) {
            this.sortDirection = this.sortDirection === ASC ? DESC : ASC;
        }
        else {
            this.sortColumn = columnName;
            this.sortDirection = ASC;
            this.pageNum = 1;
        }
        this.fetchHoldings();
    }
    /**
     * Determines the sort class for each column header
     * @param columnName: column name to get sort class for.
     */
    getSortNgClass(columnName) {
        if (columnName === this.sortColumn) {
            if (this.sortDirection === DESC)
                return 'th-sort-desc';
            if (this.sortDirection === ASC)
                return 'th-sort-asc';
        }
        return '';
    }
    setMetric(metric) {
        if (metric !== this.metric) {
            this.metric = metric;
            const userPreferenceName = `${this.securityType}_attribution_absolute_tab_contribution_metric`;
            this.accountsService
                .putUserPreferences({
                [userPreferenceName]: this.metric,
            })
                .subscribe();
            this.fetchHoldings();
        }
    }
    fetchHoldings() {
        if (this.fetchSubscription$ !== null)
            this.fetchSubscription$.unsubscribe();
        this.fetchSubscription$ = this.securitiesService
            .getAttributionTableData(this.securityId, this.pageNum, this.sortColumn, this.sortDirection, this.metric, this.holdingsLayer, this.asOfDate, this.asOfDateCustom ? formatDateString(this.asOfDateCustom) : '')
            .subscribe({
            next: (holdingData) => {
                this.holdings = holdingData.holdings;
                this.paginationInfo = holdingData.pagination_info;
            },
            error: () => {
                this.holdings = [];
                this.loading = false;
            },
            complete: () => {
                this.loading = false;
            },
        });
    }
    /**
     * Handles export dropdown selection.
     * @param format: Export format.
     */
    handleExport(format) {
        switch (format) {
            case CSV_FORMAT:
                this.securitiesService
                    .getAttributionTableDataExport(this.securityId, CSV_FORMAT, this.sortColumn, this.sortDirection, this.metric, this.holdingsLayer, this.asOfDate, this.asOfDateCustom ? formatDateString(this.asOfDateCustom) : '')
                    .subscribe({
                    next: (rsp) => {
                        const contentType = rsp.headers.get('content-type');
                        const response = {
                            ...rsp,
                            body: new Blob([rsp.body], { type: contentType }),
                        };
                        downloadFileFromPostResponse(response);
                    },
                });
                break;
            case PDF_FORMAT:
                this.pdfTitleModal.openModal();
                break;
            default:
                break;
        }
    }
    /**
     * Exports the table to PDF.
     * @param title: PDF title.
     */
    exportPDF(title) {
        this.exportLoading = true;
        this.securitiesService
            .getAttributionTableDataExport(this.securityId, PDF_FORMAT, this.sortColumn, this.sortDirection, this.metric, this.holdingsLayer, this.asOfDate, this.asOfDateCustom ? formatDateString(this.asOfDateCustom) : '', title)
            .subscribe({
            next: (response) => {
                downloadUrl(response.pdf_url);
                this.exportLoading = false;
            },
            error: () => {
                this.exportLoading = false;
            },
        });
    }
}
AttributionAbsoluteTableComponent.ɵfac = function AttributionAbsoluteTableComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AttributionAbsoluteTableComponent)(i0.ɵɵdirectiveInject(i1.AccountsService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i2.FeatureService), i0.ɵɵdirectiveInject(i3.SecuritiesService)); };
AttributionAbsoluteTableComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AttributionAbsoluteTableComponent, selectors: [["ycn-attribution-absolute-table"]], viewQuery: function AttributionAbsoluteTableComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.pdfTitleModal = _t.first);
    } }, inputs: { metric: "metric", securityId: "securityId", securityName: "securityName", securityType: "securityType", asOfDateCustom: "asOfDateCustom", asOfDate: "asOfDate", holdingsLayer: "holdingsLayer" }, standalone: false, decls: 27, vars: 19, consts: [["absoluteAttributionTableHelpModal", ""], ["pdfTitleModal", ""], [1, "panel", "panel-data"], [1, "panel-header"], [1, "panel-title"], [1, "help-toggler", 3, "click"], ["class", "panel-actions", 4, "ngIf"], [1, "panel-content"], [3, "title"], ["class", "table", "style", "min-height: 200px", 4, "ngIf"], [1, "panel-actions"], [1, "panel-action"], [1, "panel-results-count"], ["ycnDisabled", "", 1, "btn", "btn-secondary", 3, "click", "disabled"], ["ycnIcon", "", 3, "name"], [1, "divider-vertical"], [1, "panel-action", "mr-2"], [3, "loaderMessage", 4, "ngIf"], [3, "submitHandler", "defaultTitle", "submitButtonText"], [3, "loadingText", "modalTrigger"], [1, "nav", "nav-tabs"], [1, "nav-item"], ["href", "javascript:void(0)", 1, "nav-link", 3, "click", "ngClass"], [1, "panel-action", 2, "position", "relative"], [3, "handler", "buttonClass", "config", "dropdownClass"], [1, "table", 2, "min-height", "200px"], [1, "text-left", 3, "click", "ngClass"], [2, "padding-top", "0", "padding-bottom", "0"], [3, "click", "ngClass"], [1, "text-right", 3, "click", "ngClass"], [4, "ngFor", "ngForOf"], [1, "text-right"], [3, "loaderMessage"]], template: function AttributionAbsoluteTableComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 2)(1, "div", 3)(2, "h3", 4);
        i0.ɵɵtext(3, "Attribution Table\u00A0 ");
        i0.ɵɵelementStart(4, "span", 5);
        i0.ɵɵlistener("click", function AttributionAbsoluteTableComponent_Template_span_click_4_listener() { i0.ɵɵrestoreView(_r1); const absoluteAttributionTableHelpModal_r2 = i0.ɵɵreference(23); return i0.ɵɵresetView(absoluteAttributionTableHelpModal_r2.openModal("attribution_absolute_table")); });
        i0.ɵɵtext(5, " (?)");
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(6, AttributionAbsoluteTableComponent_div_6_Template, 11, 9, "div", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 7);
        i0.ɵɵelement(8, "ycn-module-upsell", 8);
        i0.ɵɵtemplate(9, AttributionAbsoluteTableComponent_table_9_Template, 30, 9, "table", 9);
        i0.ɵɵelementStart(10, "div", 10)(11, "div", 11)(12, "div", 12);
        i0.ɵɵtext(13);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(14, "div", 11)(15, "button", 13);
        i0.ɵɵlistener("click", function AttributionAbsoluteTableComponent_Template_button_click_15_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.pageChanged(ctx.pageNum - 1)); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(16, "svg", 14);
        i0.ɵɵelementEnd()();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelement(17, "div", 15);
        i0.ɵɵelementStart(18, "div", 16)(19, "button", 13);
        i0.ɵɵlistener("click", function AttributionAbsoluteTableComponent_Template_button_click_19_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.pageChanged(ctx.pageNum + 1)); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(20, "svg", 14);
        i0.ɵɵelementEnd()()();
        i0.ɵɵtemplate(21, AttributionAbsoluteTableComponent_ycn_loading_symbol_21_Template, 1, 1, "ycn-loading-symbol", 17);
        i0.ɵɵelementEnd()();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelement(22, "ycn-help-modal", null, 0);
        i0.ɵɵelementStart(24, "ycn-pdf-title-modal", 18, 1);
        i0.ɵɵlistener("submitHandler", function AttributionAbsoluteTableComponent_Template_ycn_pdf_title_modal_submitHandler_24_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.exportPDF($event)); });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(26, "ycn-loading-modal", 19);
    } if (rf & 2) {
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngIf", ctx.USER.authenticated);
        i0.ɵɵadvance();
        i0.ɵɵclassProp("overflow-auto", ctx.USER.authenticated);
        i0.ɵɵadvance();
        i0.ɵɵproperty("title", "Attribution Table");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.loading);
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate3(" Showing ", ctx.paginationInfo.start_index, " - ", ctx.paginationInfo.end_index, " of ", ctx.paginationInfo.num_items, " Holdings ");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("disabled", ctx.pageNum === 1);
        i0.ɵɵadvance();
        i0.ɵɵproperty("name", "icon-back");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("disabled", ctx.pageNum >= ctx.paginationInfo.num_pages);
        i0.ɵɵadvance();
        i0.ɵɵproperty("name", "icon-collapse");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.loading);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("defaultTitle", ctx.securityName + " Attribution Table")("submitButtonText", "Download");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("loadingText", "Exporting Table")("modalTrigger", i0.ɵɵpureFunction1(17, _c1, ctx.exportLoading));
    } }, dependencies: [i4.NgClass, i4.NgForOf, i4.NgIf, i5.DisabledDirective, i6.HelpModalComponent, i7.IconDirective, i8.LoadingModalComponent, i9.LoadingSymbolComponent, i10.ModuleUpsellComponent, i11.PdfTitleModalComponent, i12.SimpleDropdownComponent], encapsulation: 2 });
